<template>
  <fieldset>
    <el-divider>Call Options</el-divider>
    <div class="row mb-30 col-sm-6 checkbox-container">
      <el-checkbox
        id="noCalls"
        v-model="modelValue.noCalls"
      >
        Do Not Call Me Whatsoever
      </el-checkbox>
      <div class="help-block">
        Note that if this option is enabled, the user will not get any driver arriving calls, driver canceled calls, etc!
      </div>
    </div>

    <div
      class="row mb-0"
      :class="{ 'disabled-container': modelValue.noCalls }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="driverArriving"
          v-model="modelValue.driverArriving"
        >
          Driver Arriving
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideSurgeCall"
          v-model="modelValue.scheduledRideSurgeCall"
        >
          Scheduled Ride Surge Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideCall"
          v-model="modelValue.scheduledRideCall"
        >
          Scheduled Ride Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="pricePendingRideCall"
          v-model="modelValue.pricePendingRideCall"
        >
          Price Pending Ride Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callRiderPriceChange"
          v-model="modelValue.callRiderPriceChange"
        >
          Call Rider Price Change
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callRiderDriverCanceled"
          v-model="modelValue.callRiderDriverCanceled"
        >
          Call Rider Driver Canceled
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="cancellationFeeDisputeFailedCall"
          v-model="modelValue.cancellationFeeDisputeFailedCall"
        >
          Cancellation Fee Dispute Failed Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="sendNeedLoveAutomatedCall"
          v-model="modelValue.sendNeedLoveAutomatedCall"
        >
          Send Need Love Automated Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="sendNeedLoveRefundAutomatedCall"
          v-model="modelValue.sendNeedLoveRefundAutomatedCall"
        >
          Send Need Love Refund Automated Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callRiderDriverDetails"
          v-model="modelValue.callRiderDriverDetails"
        >
          Call Rider Driver Details
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="pricePendingRideAfterDateExpiredCall"
          v-model="modelValue.pricePendingRideAfterDateExpiredCall"
        >
          Price Pending Ride After Date Expired Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callRiderTripCost"
          v-model="modelValue.callRiderTripCost"
        >
          Call Rider Trip Cost
        </el-checkbox>
        <div class="help-block">
          Note that even if this is unchecked, the rider will still get this call if they don't have an email on file
        </div>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callNewDriverInfo"
          v-model="modelValue.callNewDriverInfo"
        >
          Call New Driver Info
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callWarnNoShowFee"
          v-model="modelValue.callWarnNoShowFee"
        >
          Call Warn No Show Fee
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRidePayForAnyUnpaidServicesFailedCall"
          v-model="modelValue.scheduledRidePayForAnyUnpaidServicesFailedCall"
        >
          Scheduled Ride Pay For Any Unpaid Services Failed Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideUnpaidServicesCallIn24Hours"
          v-model="modelValue.scheduledRideUnpaidServicesCallIn24Hours"
        >
          Scheduled Ride Unpaid Services Call In 24Hours
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRidePreauthFailedCallIn24Hours"
          v-model="modelValue.scheduledRidePreauthFailedCallIn24Hours"
        >
          Scheduled Ride Preauthorization Failed Call In 24Hours
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideReminderDayBeforeCall"
          v-model="modelValue.scheduledRideReminderDayBeforeCall"
        >
          Scheduled Ride Before The Day Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledRideCustomReminderCall"
          v-model="modelValue.scheduledRideCustomReminderCall"
        >
          Scheduled Ride Custom Reminder Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryPayForAnyUnpaidServicesFailedCall"
          v-model="modelValue.scheduledGroceryPayForAnyUnpaidServicesFailedCall"
        >
          Scheduled Grocery Pay For Any Unpaid Services Failed Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryUnpaidServicesCallIn24Hours"
          v-model="modelValue.scheduledGroceryUnpaidServicesCallIn24Hours"
        >
          Scheduled Grocery Unpaid Services Call In 24 Hours
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryPreauthFailedCallIn24Hours"
          v-model="modelValue.scheduledGroceryPreauthFailedCallIn24Hours"
        >
          Scheduled Grocery Preauth Failed Call In 24Hours
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryBeforeTheDayCall"
          v-model="modelValue.scheduledGroceryBeforeTheDayCall"
        >
          Scheduled Grocery Before The Day Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledGroceryCustomReminderCall"
          v-model="modelValue.scheduledGroceryCustomReminderCall"
        >
          Scheduled Grocery Custom Reminder Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryPayForAnyUnpaidServicesFailedCall"
          v-model="modelValue.scheduledDeliveryPayForAnyUnpaidServicesFailedCall"
        >
          Scheduled Delivery Pay For Any Unpaid Services Failed Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryUnpaidServicesCallIn24Hours"
          v-model="modelValue.scheduledDeliveryUnpaidServicesCallIn24Hours"
        >
          Scheduled Delivery Unpaid Services Call In 24 Hours
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryPreauthFailedCallIn24Hours"
          v-model="modelValue.scheduledDeliveryPreauthFailedCallIn24Hours"
        >
          Scheduled Delivery Preauth Failed Call In 24 Hours
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="scheduledDeliveryReminderCall"
          v-model="modelValue.scheduledDeliveryReminderCall"
        >
          Scheduled Delivery Reminder Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callPartnerCallerAboutPartnerCredits"
          v-model="modelValue.callPartnerCallerAboutPartnerCredits"
        >
          Call Partner Caller About Partner Credits
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callPartnerCallerAboutPartnerRides"
          v-model="modelValue.callPartnerCallerAboutPartnerRides"
        >
          Call Partner Caller About Partner Rides
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="callWarnInProgressDriverCancellation"
          v-model="modelValue.callWarnInProgressDriverCancellation"
        >
          Call Warn In Progress Driver Cancellation
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="subscriptionChargeSuccessCall"
          v-model="modelValue.subscriptionChargeSuccessCall"
        >
          Subscription Charge Success Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="subscriptionChargeFailedCall"
          v-model="modelValue.subscriptionChargeFailedCall"
        >
          Subscription Charge Fail Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipRenewalReminderCall"
          v-model="modelValue.membershipRenewalReminderCall"
        >
          Subscription Renewal Reminder Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="membershipTrialWillEndIn3DaysCall"
          v-model="modelValue.membershipTrialWillEndIn3DaysCall"
        >
          Subscription Trial Will End In 3 Days Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderShoppingCall"
          v-model="modelValue.groceryOrderShoppingCall"
        >
          Grocery Order Shopping Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderShoppingCompleteCall"
          v-model="modelValue.groceryOrderShoppingCompleteCall"
        >
          Grocery Order Shopping Complete Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderInTransitCall"
          v-model="modelValue.groceryOrderInTransitCall"
        >
          Grocery Order In Transit Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderCanceledCall"
          v-model="modelValue.groceryOrderCanceledCall"
        >
          Grocery Order Canceled Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderReminderCall"
          v-model="modelValue.groceryOrderReminderCall"
        >
          Grocery Order Reminder Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="refundDepositDeniedCall"
          v-model="modelValue.refundDepositDeniedCall"
        >
          Refund Deposit Denied Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="priceConfirm"
          v-model="modelValue.priceConfirm"
        >
          Price Confirm
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceryOrderOutsideReminderCall"
          v-model="modelValue.groceryOrderOutsideReminderCall"
        >
          Grocery Order Outside Reminder Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="etaDelayCall"
          v-model="modelValue.etaDelayCall"
        >
          ETA Delay Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="deliveryArrivalCall"
          v-model="modelValue.deliveryArrivalCall"
        >
          Delivery Arrival Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="deliveryAfterOrderCall"
          v-model="modelValue.deliveryAfterOrderCall"
        >
          Delivery After Order Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="deliveryAfterHoursOrderStatusUpdateCall"
          v-model="modelValue.deliveryAfterHoursOrderStatusUpdateCall"
        >
          Delivery After Hours Order Status Update Call
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="isSendUserPhoneNumberInDriverAcceptedTextMessage"
          v-model="modelValue.isSendUserPhoneNumberInDriverAcceptedTextMessage"
        >
          Send User Phone Number in Driver Accepted Text Message
        </el-checkbox>
      </div>
    </div>

    <div
      class="row mb-0 mt-20"
      :class="{ 'disabled-container': modelValue.noCalls }"
    >
      <div class="col-sm-6 checkbox-container">
        <el-checkbox
          id="marketingCalls"
          v-model="modelValue.marketingCalls"
        >
          Marketing Calls
        </el-checkbox>
        <div class="help-block">
          Note that this disables calls but not essential marketing calls like "driver arriving" or "membership will charge in 3 days" calls
        </div>
      </div>
    </div>

    <div
      class="row mb-30"
      :class="{ 'disabled-container': modelValue.noCalls || !modelValue.marketingCalls }"
    >
      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="ridesMarketingCalls"
          v-model="modelValue.ridesMarketingCalls"
        >
          Rides Marketing Calls
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="gourmetMarketingCalls"
          v-model="modelValue.gourmetMarketingCalls"
        >
          Gourmet Marketing Calls
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="groceriesMarketingCalls"
          v-model="modelValue.groceriesMarketingCalls"
        >
          Groceries Marketing Calls
        </el-checkbox>
      </div>

      <div class="col-sm-3 checkbox-container">
        <el-checkbox
          id="weeklyCheckInMarketingCall"
          v-model="modelValue.weeklyCheckInMarketingCall"
        >
          Weekly Check In Marketing Call
        </el-checkbox>
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
});
</script>
